import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Part 1 — Entry Mount Guard
// Wrap root mounting in try/catch so fatal runtime errors are always visible.
// ES module top-level errors are silently swallowed by the browser;
// this ensures we never have an invisible blank page again.
try {
  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('[Saige] Root element #root not found in DOM');

  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} catch (err) {
  console.error('[Saige] Fatal mount error:', err);

  // Last-resort visible fallback so the user never sees a blank page
  const fallback = document.getElementById('root') || document.body;
  fallback.innerHTML = `
    <div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:system-ui;color:#334155">
      <div style="text-align:center;max-width:420px">
        <h1 style="font-size:1.5rem;margin-bottom:0.5rem">Something went wrong</h1>
        <p style="color:#64748b;margin-bottom:1rem">Saige couldn't start. Please refresh or contact support.</p>
        <button onclick="location.reload()" style="padding:0.5rem 1.5rem;background:#eab308;color:#fff;border:none;border-radius:0.5rem;cursor:pointer;font-weight:600">
          Refresh
        </button>
        <pre style="margin-top:1rem;font-size:0.75rem;color:#ef4444;text-align:left;background:#fef2f2;padding:0.75rem;border-radius:0.5rem;overflow:auto">${err?.message || err}</pre>
      </div>
    </div>
  `;
}
